import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { toastError } from "@/lib/toast";
import { delFetcher } from "@/lib/swr";
import type { User } from "@/lib/swr";
import useSWRMutation from "swr/mutation";

export const DeleteUserButton = ({ user }: { user: User }) => {
  const { toast } = useToast();
  const { trigger } = useSWRMutation(`/users`, delFetcher);

  const handleDelete = async () => {
    if (window.confirm("Mark this user as departed?")) {
      try {
        await trigger(user.id);
        toast({
          title: "Marked as departed",
          description: "User has been marked as departed",
        });
      } catch (err) {
        toastError(toast, "Failed to mark as departed", err);
      }
    }
  };

  return (
    <Button variant="destructive" size="sm" onClick={handleDelete}>
      Mark as departed
    </Button>
  );
};
